// conexoes.js
import XmlParser from './XmlParser.js';
import { versaoTeste } from './Stores.js';
import consolar from './Consolar.js';
import Constantes from './Constantes.js';
import CaixaDeDialogo from "../componentes_basicos/CaixaDeDialogo.svelte";
import LoadingTela from "../componentes_basicos/LoadingTela.svelte";

class Conexoes {
  debuga = false;
  constructor() {
    this.credenciaisFile = window.location.origin + "/credenciais.xml";
    this.baseUrl = null;
    this.defaultToken = null;
    this.isLoading = false;
    this.xmlParser = new XmlParser();
  }
  renderComponent(container, props) {
    new CaixaDeDialogo({
      target: container,
      props: props
    });
  }
  renderLoading(container, props) {
    new LoadingTela({
      target: container,
      props: props
    });
  }
  appContainer = document.getElementById('app');
  async carregarCredenciais() {
    try {
      const response = await fetch(this.credenciaisFile);
      if (!response.ok) {
        throw new Error(`Erro ao carregar credenciais: ${response.status}`);
      }

      const xmlData = await response.text();

      // Aqui você pode chamar o método Parse da instância XmlParser para analisar os dados XML
      this.baseUrl = this.xmlParser.Parse(xmlData, "url_base");
      if (this.baseUrl.includes("sandbox")) {
        versaoTeste.set(1);

      }
      // console.log(this.baseUrl.trim());
      this.defaultToken = this.xmlParser.Parse(xmlData, "token");
      // console.log(this.defaultToken.trim());
    } catch (error) {
      throw new Error(`Erro ao carregar credenciais: ${error.message}`);
    }
  }

  async conecta(api, parametros = {}, valida = null, pergunta = "") {
    let metodo = 'POST';
    let response;
    //try {
    this.isLoading = true; // Ativar a barra de carregamento
    this.renderLoading = (this.appContainer, { isLoading: this.isLoading });
    if (!this.baseUrl || !this.defaultToken) {
      await this.carregarCredenciais();
    }

    const url = `${this.baseUrl}/${api}`;
    //const queryString = metodo === 'GET' ? new URLSearchParams(parametros).toString() : '';
    //const urlComParametros = metodo === 'GET' ? (queryString ? `${url}?${queryString}` : url) : url;
    //const urlComQueryCode = parametros.query_code ? `${urlComParametros}&query_code=${parametros.query_code}` : urlComParametros;

    const headers = {
      'Content-Type': 'application/json',
    };
    /*       
     const tokenUtilizado = token || this.defaultToken;
     if (tokenUtilizado) {
      // headers['Authorization'] = `Bearer ${tokenUtilizado}`;
       
       
     }
      */
    //console.log(url);
    //console.log(parametros)
    parametros['id_empresa'] = localStorage.getItem("id_empresa");
    parametros['tk'] = localStorage.getItem("token");
    parametros['inserido_por'] = localStorage.getItem("usuario");
    parametros['versao_app'] = Constantes.versao;
    if (this.debuga) {
      parametros['debuga'] = true;
    }

    if (pergunta) {
      const confirmed = await new Promise((resolve) => {
        this.renderComponent(this.appContainer, {
          message: pergunta,
          button1Label: "Sim",
          button2Label: "Não",
          button1Action: () => resolve(true),
          button2Action: () => resolve(false)
        });
      });

      // Se o usuário clicar em "Não", cancela a ação
      if (!confirmed) {
        this.isLoading = false;
        return;
      }
    }
    consolar.log("Parametros do fetch: ", parametros);
    //console.log("Parametros do fetch: ",parametros);
    response = await fetch(url, {
      method: metodo,
      //headers: headers,
      body: metodo === 'POST' ? JSON.stringify(parametros) : undefined,
    });

    if (!response.ok) {
      consolar.log((`Erro ao chamar a API: ${response.status}`));
      // return "erro";
      // throw new Error(`Erro ao chamar a API: ${response.status}`);
    }


    //let copiaObjeto = { ...response };

    // } catch (error) {
    //  consolar.log((`Erro na conexão: ${error.message} `));
    //   return "erro";
    //   throw new Error(`Erro na conexão: ${error.message} ${response}`);
    //this.renderComponent(this.appContainer, { message: Constantes.msg_erro_conexao_bd + 2 });
    //console.log(error);
    console.log(response.text);
    //  } finally {

    //  this.isLoading = false; // Desativar a barra de carregamento
    // }
    let resultado = "";

    consolar.log("Retorno do fetch1: ", response);
    // let copia =  [...response]
//////resultado = await response.json(); /*aqui*/
    try {

      resultado = await response.json();

      consolar.log("Retorno do fetch2 ", resultado);

    } catch (error) {
      if (valida) {
        this.renderComponent(this.appContainer, { message: Constantes.msg_erro_conexao_bd + 2 });

        //   this.isLoading = false;

        return;

      }
      //resultado = await copia.json();
    }


    //   this.isLoading = false; // Desativar a barra de carregamento
    console.log("valida", valida)
    if (valida) {
      console.log("dentro do valida")
      try {
        if (!resultado.sucesso && resultado.motivo == 'duplicado') {
          this.renderComponent(this.appContainer, { message: Constantes.msg_inscricao_duplicada });
        } else if (!resultado.sucesso) {
          this.renderComponent(this.appContainer, { message: Constantes.msg_erro_conexao_bd });
        } else {
          this.renderComponent(this.appContainer, { message: Constantes.msg_inserido_sucesso });

        }

      } catch (error) {

        this.renderComponent(this.appContainer, { message: Constantes.msg_erro_conexao_bd + 2 });

      }


    }

    return resultado;

  }
}

export default Conexoes;